import React, { useState } from 'react';
import ToggleView from "../../components/ToggleView/ToggleView";
import TabsLeft from "../Tabs-left/Tabs-left";

import {
  PprojectStyled,
  PprojectLeftStyled,
  PprojectRightStyled,
  MenuStyled,
  MenuItemStyled,
  LinkStyled,
  MenuItemStyledActive,
  TabsWrap,
  TabsWrapItem,
  ContainerForToggleViewStyled
} from './style.js';
import PopupNew from "../PopupNew/PopupNew";
import LogIn from "../LogIn/LogIn";

const Tabs = ({
  managers, tabsMenu, imgPoster, textSend, type, dashboard, onToggleViewClick,
  id, typeBookmark, isInFavourites, isLoggedIn,
  firstTabs, secondTabs, thirdTabs, fourthTabs, fifthTabs,
}) => {
  const [tabs, setTabs] = useState(0);
  const [popupIsOpen, setPopupIsOpen] = useState(false);
  // menuIsOpen сбрасывался вместе с попапом, но нигде не читался — убран

  const handleTabsClick = (item) => {
    setTabs(item);
  };

  const _handleOpenPopupClick = (e) => {
    e.preventDefault();
    setPopupIsOpen((prev) => !prev);
  };

  const tabsContent = [firstTabs, secondTabs, thirdTabs, fourthTabs, fifthTabs];

  return (
    <>

      {
        (popupIsOpen && !isLoggedIn && window.innerWidth > 768)
        &&
        <PopupNew handleOpenPopupClick={_handleOpenPopupClick}>
          <LogIn
            viewType="popup"
            // handleOpenProfileMenuClick={_handleOpenProfileMenuClick}
            handleOpenPopupClick={_handleOpenPopupClick} />
        </PopupNew>
      }
      <PprojectStyled className={type === "profile" ? "profile" : ""}>
        <PprojectLeftStyled>
          <TabsLeft
            managers={managers}
            imgPoster={imgPoster}
            textSend={textSend}
            type={type}
            tabs={tabs}
            id={id}
            typeBookmark={typeBookmark}
            isInFavourites={isInFavourites}
          />
        </PprojectLeftStyled>

        <PprojectRightStyled>
          <MenuStyled>
            {tabsMenu.map((item, index) =>
              index === tabs
                ? <MenuItemStyledActive onClick={() => handleTabsClick(index)} key={index} className={!item.tabsName && "not"}>{item.tabsName}</MenuItemStyledActive>
                : (isLoggedIn === false ?
                  item.tabsName === "Видео" ?
                    (window.innerWidth < 768) ?
                      <LinkStyled key={index} className="with-icon" to="/auth">Видео </LinkStyled>
                      : <LinkStyled key={index} onClick={_handleOpenPopupClick} className="with-icon" to="/auth">Видео </LinkStyled>
                    : <MenuItemStyled onClick={() => handleTabsClick(index)} key={index} className={!item.tabsName && "not"}>{item.tabsName}</MenuItemStyled>
                  : <MenuItemStyled onClick={() => handleTabsClick(index)} key={index} className={!item.tabsName && "not"}>{item.tabsName}</MenuItemStyled>
                )
            )}
            {tabs === 1 && type === "event" && window.innerWidth > 767
              ? <ContainerForToggleViewStyled>
                <ToggleView selected={dashboard ? "dashboard" : "list"} toggleViewChange={onToggleViewClick} />
              </ContainerForToggleViewStyled>
              : null
            }
          </MenuStyled>
          <TabsWrap>
            {tabsContent[tabs] !== undefined && <TabsWrapItem>{tabsContent[tabs]}</TabsWrapItem>}
          </TabsWrap>
        </PprojectRightStyled>
      </PprojectStyled>
    </>
  );
};

export default Tabs;
